export const localFlags = {
  emailSuppressionEnabled: false,
  sparkpostLocalUrl: 'http://localhost:4000'
};
